<div class="main-menu-sidebar-overlay" *ngIf="isOpen && isMobile" (click)="closeSidebar()"></div>

<div class="main-menu-sidebar" [class.open]="isOpen">
  <div class="sidebar-header">
    <button class="close-button" (click)="closeSidebar()" nbButton ghost>
      <nb-icon icon="chevron-left-outline"></nb-icon>
    </button>
    <h6>{{ 'menu.menu' | translate }}</h6>
  </div>

  <div class="sidebar-content">
    <div *ngFor="let item of menu" class="menu-item menu-item-clickable" (click)="navigateToRoute(item)">
      <div class="menu-item-header">
        <nb-icon [icon]="item.icon"></nb-icon>
        <span>{{ item.title }}</span>
      </div>
    </div>
  </div>
</div>

<!-- User Account Sidebar -->
<ngx-user-account-sidebar 
  [isOpen]="isAccountSidebarOpen" 
  [user]="user"
  (onClose)="closeAccountSidebar()"
  (onLogout)="onAccountSidebarLogout()">
</ngx-user-account-sidebar>